import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-iquanta-features',
  templateUrl: './iquanta-features.component.html',
  styleUrls: ['../../new-home/main-page.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class IquantaFeaturesComponent implements OnInit{

  constructor(){}

  ngOnInit(): void {
    
  }

  featuresTab: any = 'dual'

  featuresTabChange(val: any) {
    this.featuresTab = val;
  }

}
